<script>
    import { createEventDispatcher } from 'svelte'
    import { getMenuContext } from './Menu.svelte'
    const dispatch = createEventDispatcher()
    const menu = getMenuContext();

    function onSelect() {
        menu.itemSelected();
        dispatch("select");
    }
</script>

<li role="button" on:click={() => onSelect()}><slot/></li>

<style>
	li {
		padding: 0.75rem 1.25rem;
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	li:hover {
		background-color: var(--grid-color)
	}

    li > :global(.feather) {
        margin-right: 1rem;
    }
</style>